import React from 'react';

function Help() {
  return (
    <div className="container">
      <section className="content-section">
        <h2>Help Center</h2>
        <p>
          Welcome to the Nouria Help Center. We're here to help you get the most out of your gut health journey.
        </p>

        <h4>How do I track a meal?</h4>
        <p>
          Simply use the '+' button on the home screen or navigate to the 'Add Food' section. As you log fiber and protein, watch your Inner Garden grow!
        </p>

        <h4>What is the Nouria Score?</h4>
        <p>
          Your Nouria Score is a daily snapshot of your gut health progress (0-100), calculated based on your fiber, protein, and fermented food intake.
        </p>

        <h4>How are my insights generated?</h4>
        <p>
          Our powerful AI analyzes your logged meals and symptoms to identify correlations. These insights help you understand which foods make your inner garden (and you!) thrive.
        </p>

        <h4>Is my data secure?</h4>
        <p>
          Absolutely. We use industry-leading encryption to protect your data. Your privacy is our top priority. For more details, please see our <a href="/privacy">Privacy Policy</a>.
        </p>

        <h3>Contact Us</h3>
        <p>
          Can't find the answer you're looking for? Our support team is here to help. Please email us at <a href="mailto:support@nouria.fit">support@nouria.fit</a> and we'll get back to you as soon as possible.
        </p>
      </section>
    </div>
  );
}

export default Help;
